import './index.css';

console.log('test')

document.body.appendChild(document.createElement('h2')).textContent = 'Hello, world!';
